<script lang="ts">
    import { onMount } from 'svelte';
    import { storeEvents } from '../scripts/classes/actu';
    import EventInsight from './EventInsight.svelte';

    onMount(async () => {
        window.scrollTo(0,0);
	});

</script>
    
<style lang="scss">

    .events {
        width: 100%;
        &__scroll {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: nowrap;
            overflow-x: scroll;
            overflow-y: hidden;
            scrollbar-color: $color_primary $color_grey;
            scrollbar-width: auto;
            margin: 0 0 20px 0;
        }
    }

    @include large {
        .events {
            &__scroll {
                flex-direction: row;
            }
        }

    }

</style>

<div class="events">
    <div class="events__scroll">
        {#each $storeEvents as event}
        <EventInsight inEvent={event} />
        {/each}    
    </div>
</div>
